<div class="container flex flex-row justify-between items-center">
  <div class=""
       matTooltip="{{item.cells[fieldDefinition.key] && item.cells[this.fieldDefinition.key].value?.toolTip ? item.cells[this.fieldDefinition.key].value?.toolTip : ''}}">
    <a class="flex flex-row justify-start items-center"
       particleAnalytics
       analyticsCategory="link-cell-viewer"
       [ngClass]="!item.isReadOnly || fieldDefinition?.metaData?.CanCellUnlock === 'true' ? 'link-color' : 'disabled'"
       [analyticsAction]="item.cells[fieldDefinition.key]?.displayText"
       (click)="onHyperLinkClick('View')"

    >

      <div class="ellipsis full-grow-no-shrink-no-basis "  title="{{item.cells[fieldDefinition.key]?.displayText}}">
        {{item.cells[fieldDefinition.key]?.displayText}}
      </div>

    </a>

  </div>
  <button
    *ngIf="!fieldDefinition.isReadOnly && (!item.isReadOnly || fieldDefinition?.metaData?.CanCellUnlock === 'true')"
    matTooltip="Download This File" (click)="onDownloadClick('Download')" mat-icon-button class="icon-dropdown-button">
    <i class="fas fa-download"></i>
  </button>


</div>
